import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { Button, variantActionsProps } from 'shared/ui'
import { Table } from 'shared/ui/TableNew'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import { useEventBroadcastCanceled } from 'entities/Broadcast/events/EventBroadcastCanceled'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type RowBroadcastOneTime } from 'entities/Broadcast/model/Table/RowBroadcastOneTime'
import { getColumnsOneTime } from 'pages/broadcasts/ui/BroacastList/ui/BroadcastTable/getColumns'
import { getBroadcastActions } from 'pages/broadcasts/ui/BroadcastActions'
import { useBroadcastDetailRecurringContext } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailRecurring/context/context'
import styles from './styles.module.scss'

export const RecurringTable = observer(() => {
  const { broadcastRow, tableStore } = useBroadcastDetailRecurringContext()
  const entities = useEntitiesContext()
  const getRowLink = (row: RowBroadcastOneTime) =>
    `/${BroadcastsRoutes.root}/${
      row.status === 'draft' || row.status === 'scheduled'
        ? BroadcastsRoutes.edit
        : BroadcastsRoutes.view
    }/${row.id}`

  const columns = useMemo(() => getColumnsOneTime('sms', entities), [entities])

  useEventBroadcastCanceled(broadcastRow.origin.handleUpdate)

  useEffect(() => {
    tableStore.setTotal(broadcastRow.rows.length)
  }, [broadcastRow.rows.length])

  useEffect(() => {
    tableStore.setLoading(broadcastRow.loading)
  }, [broadcastRow.loading])

  const rows = useMemo(
    () =>
      broadcastRow.rows.map((item) => {
        item.setActionsProps({
          ...variantActionsProps.table,
          actions: getBroadcastActions({
            broadcast: item.origin,
            onSuccessDelete: () => {
              broadcastRow.onDelete([item.id])
            },
            entities,
          }),
        })

        return item
      }),
    [broadcastRow.rows.length]
  )

  return (
    <div className={styles.wrap}>
      <Table
        ariaLabel={'RecurringTable'}
        store={tableStore}
        columns={columns}
        pinnedColumnIds={['expandedColumn', 'name']}
        emptyStateProps={{
          text: 'No broadcasts found',
          noIcon: true,
        }}
        rows={rows}
        loading={broadcastRow.loading}
        getRowLink={getRowLink}
        hidePagination
        sxTable={{ marginRight: 2, width: 'calc(100% - 16px)' }}
        bottomTableContent={
          <td className={styles.moreBtn}>
            <Button
              text={'Load more'}
              onClick={broadcastRow.onLoadMore}
              typeBtn={'contained'}
              contained={'secondary'}
              size={'small'}
              loading={broadcastRow.loadingMore}
              disabled={!broadcastRow.isMoreExpand}
            />
          </td>
        }
      />
    </div>
  )
})
